import OrderFlowName from 'todistukset-ui/src/vtj/OrderFlowName.enum'

enum StepRoutes {
  INSTRUCTIONS = 'aloita-tilaaminen',
  EIDAS_PERSONAL_INFORMATION = 'henkilotiedot',
  BASIC_INFORMATION = 'tiedot-todistuksessa',
  USAGE_REGION = 'kayttokohde',
  ADDITIONAL_SELECTIONS = 'lisavalinnat',
  DELIVERY_METHOD = 'toimitustapa',
  SUMMARY = 'yhteenveto',
  ORDER_COMPLETE = 'tilaus-valmis',
  AET_INSTRUCTIONS = StepRoutes.INSTRUCTIONS,
  AET_ORDERER_INFO = 'tilaajan-tiedot',
  AET_SPOUSE_INFO = 'puolison-tiedot',
  AET_LASTNAME_CHOICE = 'sukunimen-valinta',
  AET_ADDITIONAL_SELECTIONS = StepRoutes.ADDITIONAL_SELECTIONS,
  AET_CONTACT_INFO = 'yhteystiedot',
  AET_SUMMARY = StepRoutes.SUMMARY,
  AET_ORDER_COMPLETE = 'aet-tilaus-valmis',
  AET_SIGNER_INSTRUCTIONS = StepRoutes.AET_INSTRUCTIONS,
  AET_SIGNER_ORDERER_INFO = StepRoutes.AET_ORDERER_INFO,
  AET_SIGNER_SPOUSE_INFO = StepRoutes.AET_SPOUSE_INFO,
  AET_SIGNER_LASTNAME_CHOICE = StepRoutes.AET_LASTNAME_CHOICE,
  AET_SIGNER_CONTACT_INFO = StepRoutes.AET_CONTACT_INFO,
  AET_SIGNER_SUMMARY = StepRoutes.SUMMARY,
  AET_SIGNER_ORDER_COMPLETE = StepRoutes.AET_ORDER_COMPLETE,
  AET_SIGNER_TODISTUSPYYNTO_REJECTED = 'aet-todistuspyynto-hylatty',
  UAET_INSTRUCTIONS = StepRoutes.INSTRUCTIONS,
  UAET_ORDERER_INFO = StepRoutes.AET_ORDERER_INFO,
  UAET_SPOUSE_INFO = StepRoutes.AET_SPOUSE_INFO,
  UAET_USAGE_REGION = StepRoutes.USAGE_REGION,
  UAET_ADDITIONAL_SELECTIONS = StepRoutes.ADDITIONAL_SELECTIONS,
  UAET_CONTACT_INFO = StepRoutes.AET_CONTACT_INFO,
  UAET_SUMMARY = StepRoutes.SUMMARY,
  // Note, if this is changed to something else, verify that packages/todistukset-ui/src/vtj/components/order-wizard/todistusSteps.ts#getOrderCompleteUrl works.
  UAET_ORDER_COMPLETE = StepRoutes.ORDER_COMPLETE,
}

const stepTextKeysVtjOte: { [k: string]: string } = {
  [StepRoutes.INSTRUCTIONS]: 'wizardNavigationInstructions',
  [StepRoutes.EIDAS_PERSONAL_INFORMATION]:
    'wizardNavigationPersonalInformation',
  [StepRoutes.BASIC_INFORMATION]: 'wizardNavigationBasicInformation',
  [StepRoutes.USAGE_REGION]: 'wizardNavigationUsageRegion-v2',
  [StepRoutes.ADDITIONAL_SELECTIONS]: 'wizardNavigationAdditionalSelections',
  [StepRoutes.DELIVERY_METHOD]: 'wizardNavigationDeliveryMethod',
  [StepRoutes.SUMMARY]: 'wizardNavigationSummary',
  [StepRoutes.ORDER_COMPLETE]: 'wizardNavigationOrderComplete',
}

const stepTextKeysAetOrderer: { [k: string]: string } = {
  [StepRoutes.AET_INSTRUCTIONS]: 'wizardNavigationAetStart',
  [StepRoutes.AET_ORDERER_INFO]: 'wizardNavigationAetOrdererInfo',
  [StepRoutes.AET_SPOUSE_INFO]: 'wizardNavigationAetSpouseInfo',
  [StepRoutes.AET_LASTNAME_CHOICE]: 'wizardNavigationAetLastnameChoice',
  [StepRoutes.AET_ADDITIONAL_SELECTIONS]:
    'wizardNavigationAetAdditionalSelection',
  [StepRoutes.AET_CONTACT_INFO]: 'wizardNavigationAetContactInfo',
  [StepRoutes.AET_SUMMARY]: 'wizardNavigationAetSummary',
  [StepRoutes.AET_ORDER_COMPLETE]: 'wizardNavigationAetOrderComplete',
}

const stepTextKeysAetSigner: { [k: string]: string } = {
  [StepRoutes.AET_SIGNER_INSTRUCTIONS]:
    stepTextKeysAetOrderer[StepRoutes.AET_INSTRUCTIONS],
  [StepRoutes.AET_SIGNER_ORDERER_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_ORDERER_INFO],
  [StepRoutes.AET_SIGNER_SPOUSE_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_SPOUSE_INFO],
  [StepRoutes.AET_SIGNER_LASTNAME_CHOICE]:
    stepTextKeysAetOrderer[StepRoutes.AET_LASTNAME_CHOICE],
  [StepRoutes.AET_SIGNER_CONTACT_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_CONTACT_INFO],
  [StepRoutes.AET_SIGNER_SUMMARY]:
    stepTextKeysAetOrderer[StepRoutes.AET_SUMMARY],
  [StepRoutes.AET_SIGNER_ORDER_COMPLETE]:
    stepTextKeysAetOrderer[StepRoutes.AET_ORDER_COMPLETE],
  [StepRoutes.AET_SIGNER_TODISTUSPYYNTO_REJECTED]:
    'wizardNavigationAetTodistuspyyntoRejected',
}

const stepTextKeysUaet: { [k: string]: string } = {
  [StepRoutes.UAET_INSTRUCTIONS]:
    stepTextKeysAetOrderer[StepRoutes.AET_INSTRUCTIONS],
  [StepRoutes.UAET_ORDERER_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_ORDERER_INFO],
  [StepRoutes.UAET_SPOUSE_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_SPOUSE_INFO],
  [StepRoutes.UAET_USAGE_REGION]: stepTextKeysVtjOte[StepRoutes.USAGE_REGION],
  [StepRoutes.UAET_ADDITIONAL_SELECTIONS]:
    stepTextKeysVtjOte[StepRoutes.ADDITIONAL_SELECTIONS],
  [StepRoutes.UAET_CONTACT_INFO]:
    stepTextKeysAetOrderer[StepRoutes.AET_CONTACT_INFO],
  [StepRoutes.UAET_SUMMARY]: stepTextKeysVtjOte[StepRoutes.SUMMARY],
  [StepRoutes.UAET_ORDER_COMPLETE]:
    stepTextKeysVtjOte[StepRoutes.ORDER_COMPLETE],
}

const vtjOteOrderFlows: string[] = [
  OrderFlowName.ASUINPAIKKATODISTUS,
  OrderFlowName.AVIOLIITTOTODISTUS,
  OrderFlowName.ELOSSAOLOTODISTUS,
  OrderFlowName.SIVIILISAATYTODISTUS,
  OrderFlowName.SYNTYMATODISTUS,
]

export function getStepTitleKey(page: string, step: string): string {
  if (vtjOteOrderFlows.includes(page)) {
    return step in stepTextKeysVtjOte ? stepTextKeysVtjOte[step] : ''
  }
  if (page === OrderFlowName.AETTODISTUS_ORDERER) {
    return step in stepTextKeysAetOrderer ? stepTextKeysAetOrderer[step] : ''
  }
  if (page === OrderFlowName.AETTODISTUS_SIGNER) {
    return step in stepTextKeysAetSigner ? stepTextKeysAetSigner[step] : ''
  }
  if (page === OrderFlowName.UAETTODISTUS) {
    return step in stepTextKeysUaet ? stepTextKeysUaet[step] : ''
  }
  return ''
}

export default StepRoutes
